import { GenericShopApiResponse } from '../../../common/apiAdapters/types';

export const HELP_CENTER_IDENTIFIER = 'help_center';

export interface HelpCenterArticle {
    title: string;
    url: string;
}

export interface HelpCenterArticlesData {
    data: HelpCenterArticle[];
}

export interface HelpCenterState {
    articles: HelpCenterArticle[];
    isFetching: boolean;
    didInvalidate: boolean;
    identifier: string;
}

export type HelpCenterArticlesResponse = GenericShopApiResponse<HelpCenterArticlesData>;
